import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("glg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Build a usable src from a stored media value (relative /api/media path, storage path, or full URL).
export const mediaUrl = (val) => {
  if (!val) return "";
  if (val.startsWith("http")) return val;
  if (val.startsWith("/api/")) return `${BACKEND_URL}${val}`;
  return `${API}/media/${val}`;
};

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { path, url }
};
